import(/* webpackMode: "eager" */ "/tmp/8def0913fcb00a8/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8def0913fcb00a8/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8def0913fcb00a8/src/components/Header.tsx");
